import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

import { useCookieBannerVisible } from "@/lib/cookie-consent";

export const WHATSAPP_NUMBER = "40738792499";
export const WHATSAPP_LABEL = "+40 738 792 499";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi! I'd like to rent a car in Bucharest.",
)}`;

export function WhatsAppBubble() {
  const [open, setOpen] = useState(false);
  const bannerVisible = useCookieBannerVisible();

  useEffect(() => {
    if (bannerVisible) return;
    const t = window.setTimeout(() => setOpen(true), 2500);
    return () => window.clearTimeout(t);
  }, [bannerVisible]);

  return (
    <div
      className="fixed right-4 z-40 flex flex-col items-end gap-3 transition-[bottom] duration-300 sm:right-5 print:hidden"
      style={{ bottom: bannerVisible ? "calc(1rem + var(--cookie-banner-offset, 8rem))" : "1.25rem" }}
    >
      {open && !bannerVisible && (
        <div className="animate-scale-in relative w-64 rounded-2xl border border-border bg-card p-4 shadow-card">
          <button
            type="button"
            aria-label="Close WhatsApp message"
            onClick={() => setOpen(false)}
            className="absolute right-2 top-2 rounded-full p-1 text-muted-foreground transition-colors hover:text-foreground"
          >
            <X className="size-4" />
          </button>
          <p className="eyebrow text-gold">Car Rental Bucharest</p>
          <p className="mt-2 text-sm text-muted-foreground">
            Questions about a booking? Chat with us on WhatsApp — we reply fast.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-semibold text-gold-foreground transition-opacity hover:opacity-90"
          >
            <MessageCircle className="size-4" /> Start chat
          </a>
        </div>
      )}

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
        onClick={() => setOpen(false)}
        className="grid size-14 place-items-center rounded-full bg-gold text-gold-foreground shadow-card transition-transform hover:scale-105"
      >
        <MessageCircle className="size-7" />
      </a>
    </div>
  );
}
